export default __webpack_public_path__ + "static/media/FruitShop-bro.26d1b03e.svg";